/**
 * HubSpot configuration
 * Account IDs are loaded from environment variables
 */

const HUBSPOT_ACCOUNT_ID = import.meta.env.VITE_HUBSPOT_ACCOUNT_ID;

export const HUBSPOT_SCRIPT_URL = `//js-eu1.hs-scripts.com/${HUBSPOT_ACCOUNT_ID}.js`;
